// @flow

import {
  GET_MANIFEST_REQUEST,
  GET_MANIFEST_SUCCESS,
  GET_MANIFEST_FAILURE
} from '../actions/manifest'

const initialState : {
  isFetching: boolean,
  data: ?Object
} = {
  isFetching: false,
  data: null
}

export function manifest (state: Object = initialState, action: Object) : Object {
  switch (action.type) {

    case GET_MANIFEST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case GET_MANIFEST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.manifest
      })

    case GET_MANIFEST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        data: null
      })

    default:
      return state
  }
}
